<template>
	<div class="pagesContent">
		<el-card class='mb-20'>
			<el-row class='mb-20'>
				<el-col :span="22">
					<h4><i class="el-icon-notebook-2"></i> 服务器穿透</h4>
				</el-col>
				<el-col :span="2">
					<el-button type="primary" size="medium" icon="el-icon-plus" @click="dialog = true">添加
					</el-button>
				</el-col>
			</el-row>
			<el-form :model="query" inline>
				<el-form-item label="公司名称">
					<el-input @input="SearchAntiShake" clearable v-model="query.likeCompanyName" placeholder="请输入公司名称"></el-input>
				</el-form-item>
				<el-form-item label="代理名称">
					<el-input @input="SearchAntiShake" clearable v-model="query.likeAgentName" placeholder="请输入代理名称"></el-input>
				</el-form-item>
				<el-form-item label="云服务器编号">
					<el-select v-model="query.frpServerId" clearable placeholder="请选择云服务器编号" @change="SearchAntiShake">
						<el-option v-for="(item,ind) in servers" :key='ind' :label="item.label" :value='item.Id'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="自定义域名">
					<el-input @input="SearchAntiShake" clearable v-model="query.likeCustomDomains" placeholder="请输入自定义域名"></el-input>
				</el-form-item>
				<el-form-item label="远程端口">
					<el-input @input="SearchAntiShake" clearable v-model="query.likeRemotePort" placeholder="请输入远程端口"></el-input>
				</el-form-item>
			</el-form>
		</el-card>
		
		<el-card>
			<el-table :data="frpData" border :span-method="objectSpanMethod">
				<el-table-column prop="Id" label="添加/删除" width="90">
					<template slot-scope="{row}">
						<span class="el-icon-plus" style="margin: 0 5px;" @click="editAddNode(row,1)"></span>
						<span class="el-icon-delete" @click="delFprItem(row)"></span>
					</template>
				</el-table-column>
				<el-table-column prop='CompanyId' label="公司编号"></el-table-column>
				<el-table-column prop='CompanyName' label="公司名称"></el-table-column>
				<el-table-column label="云主机">
					<template slot-scope='scope'>
						<div>
							<el-select v-model="scope.row.frpServerId" placeholder="请选择" size="small"
								@change="modifyPenetration(scope.row)">
								<el-option v-for="(item,ind) in servers" :key="ind" :label="item.label" :value="item.Id">
									<span style="float: left">{{ item.ServerAddress +':'+ item.ServerPort }}</span>
								</el-option>
							</el-select>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop='name' label="代理名称"></el-table-column>
				<el-table-column label="软件信息">
					<template slot-scope="{row}">
						<div>{{ row | editionFilter(edition) }}</div>
					</template>
				</el-table-column>
				<el-table-column prop='type' label="穿透类型" width="77"></el-table-column>
				<el-table-column prop='local_ip' label="客户端IP"></el-table-column>
				<el-table-column prop='local_port' label="客户端端口号"></el-table-column>
				<el-table-column prop='custom_domains' label="自定义域名"></el-table-column>
				<el-table-column prop='remote_port' label="远程端口"></el-table-column>
				<el-table-column label="消息加密" width="77">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.use_encryption" :disabled="true"></el-switch>
					</template>
				</el-table-column>
				<el-table-column label="消息压缩" width="77">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.use_gzip" :disabled="true"></el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="{row}">
						<el-button v-show="row.name" size="mini" type="primary" @click="editAddNode(row,2)">编辑</el-button>
						<el-button v-show="row.name" size="mini" type="danger" @click="delRowModify(row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="query.num" :page-sizes="[10, 20, 30, 40]" :page-size="query.size"
				layout="total,sizes, prev, pager, next" :total="total">
			</el-pagination>
		</el-card>
		
		<el-dialog title="穿透客户端信息" width="30%" :visible.sync="dialog" center :close-on-click-modal='false'
			@close='()=>{$refs.nodeForm.resetFields()}'>
			<div style="display: flex;justify-content: center;">
				<el-form :model="form" label-position='top' :rules="rules" ref="nodeForm">
					<el-form-item label="公司名称" prop="CompanyId">
						<el-select v-model="form.CompanyId" filterable remote placeholder="请输入关键词"
							:remote-method="remoteMethod" :loading="loading">
							<el-option v-for="(item,ind) in companyList" :key="ind" :label="item.CompanyName"
								:value="item.CompanyId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="穿透公网服务器编号" prop="frpServerId">
						<el-select v-model="form.frpServerId" placeholder="请选择">
							<el-option v-for="(item,ind) in servers" :key="ind" :label="item.label" :value="item.Id">
								<span style="float: left">{{ item.ServerAddress +':'+ item.ServerPort }}</span>
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" >
				<el-button @click='dialog = false' type="danger">取消</el-button>
				<el-button @click='setFrp(form)' type="primary">提交</el-button>
			</span>
		</el-dialog>
		<!-- 添加修改穿透节点 -->
		<el-dialog center width="30%" :visible.sync="penetrationNode" @close='()=>{formData = $options.data.call(this).formData}'>
			<el-form :model="formData" ref="formData" label-position="left" label-width="100px">
				<el-form-item label="代理名称" :label-width="formLabelWidth">
					<el-input v-model="formData.name"></el-input>
				</el-form-item>
				<el-form-item label="软件信息" :label-width="formLabelWidth">
					<el-select v-model="formData.SoftwareInd" placeholder="请选择软件信息" @change="setSoftware(formData.SoftwareInd)">
						<el-option v-for="(item,ind) in edition" :key='ind' :label='item.label' :value='ind'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="穿透类型" :label-width="formLabelWidth">
					<el-input v-model="formData.type" ></el-input>
				</el-form-item>
				<el-form-item label="客户端IP" :label-width="formLabelWidth">
					<el-input v-model="formData.local_ip"></el-input>
				</el-form-item>
				<el-form-item label="客户端端口号" :label-width="formLabelWidth">
					<el-input v-model="formData.local_port"></el-input>
				</el-form-item>
				<el-form-item label="自定义域名" :label-width="formLabelWidth">
					<el-input v-model="formData.custom_domains" ></el-input>
				</el-form-item>
				<el-form-item label="远程端口" :label-width="formLabelWidth">
					<el-input v-model="formData.remote_port"></el-input>
				</el-form-item>
				<el-form-item label="消息加密" :label-width="formLabelWidth">
					<el-switch v-model="formData.use_encryption"></el-switch>
				</el-form-item>
				<el-form-item label="消息压缩" :label-width="formLabelWidth">
					<el-switch v-model="formData.use_gzip"></el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="penetrationNode = false">取 消</el-button>
				<el-button type="primary" @click="sumbitNode">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		filters:{
			editionFilter(row,edit){
				var a = ''
				var b = ''
				edit.map(rs=>{
					if(row.SoftwareId==rs.SoftwareId){
						a=rs.Software.Name
					}
					if(row.VersionTypeId==rs.VersionTypeId){
						b=rs.SoftwareVersionType.Name
					}
				})
				if(!a&&!b&&!row.Version){
					return ''
				}else {
					return `${a}-${b}-${row.Version}`
				}
			}
		},
		data() {
			return {
				spanArr: [],
				// 公司列表
				companyList: [],
				// 要添加的节点信息
				form:{},
				formData:{
					SoftwareInd:undefined,
					name:'',
					SoftwareId:'',
					type:'',
					local_ip:'',
					local_port:'',
					custom_domains:'',
					remote_port:'',
					VersionTypeId:null,
					Version:'',
					use_encryption:false,
					use_gzip:false,
				},
				commonNodeData:{
					ind:null
				},
				// 验证规则
				rules: {
					CompanyId: [
						{ required: true, message: '请选择公司', trigger: 'blur' }
					],
					frpServerId: [
						{ required: true, message: '请选择穿透公网服务器编号', trigger: 'blur' }
					]
				},
				// 弹出层是否显示
				dialog: false,
				penetrationNode:false,
				// 查询条件
				query: {
					likeCompanyName: "",
					likeAgentName: "",
					frpServerId: null,
					likeCustomDomains: "",
					likeRemotePort: "",
					num: 1,
					size: 10,
				},
				// 总页数
				total: 0,
				// 表格内容展开收起
				open: false,
				// 穿透节点
				frpData: [],
				// 所有云主机
				servers: [],
				// 版本信息
				edition: []
			}
		},
		mounted() {
			//查询所有frp云主机
			this.getFrpAll()
			//查询所有frp穿透配置信息
			this.getPaginatedClient()
			// 查询所有软件
			this.getSoftwareVerAll()
		},
		methods: {
			rowspan() {
				let position=0;
				this.frpData.forEach((item, index) => {
					if (index === 0) {
						this.spanArr.push(1);
						position = 0;
					} else {
						if (this.frpData[index].CompanyId=== this.frpData[index - 1].CompanyId) {
							this.spanArr[position] += 1;
							this.spanArr.push(0);
						} else {
							this.spanArr.push(1);
							position = index;
						}
					}
				});
			},
			// 合并行
			objectSpanMethod({ row, column, rowIndex, columnIndex }){
				// console.log(row, column, rowIndex, columnIndex)
				if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2|| columnIndex === 3) {
					const _row = this.spanArr[rowIndex];
					const _col = _row > 0 ? 1 : 0;
					return {
						rowspan: _row,
						colspan: _col
					};
				}
			},
			editAddNode(row,ind){
				console.log(row,ind)
				this.commonNodeData=row
				this.commonNodeData.ind = ind
				if(ind==2){
					this.formData = {...row}
					this.formData.SoftwareInd = undefined
					this.edition.map((rs,index)=>{
						// console.log(rs,index)
						if(row.SoftwareId==rs.SoftwareId&&row.Version==rs.Version&&row.VersionTypeId==rs.VersionTypeId){
							this.formData.SoftwareInd = index
						}
					})
				}
				this.penetrationNode = true
			},
			sumbitNode(){
				if(this.commonNodeData.ind==1){
					var data = {
						...this.formData,
						frpClientId:this.commonNodeData.fid,
					}
				}else{
					var data = {...this.formData}
				}
				console.log(data)
				this.$http.setClientAgent(data).then(res => {
					console.log(res)
					if (res.data.Code != 200) return this.$message.error(res.data.MsgText)
					this.$message.success('添加成功')
					this.penetrationNode = false
					this.getPaginatedClient()
					// row.modify = false
					// this.getAllClientAgent(row.frpClientId)
				})
			},

			// 选择软件信息
			setSoftware(ind) {
				var val = this.edition[ind]
				console.log(val)
				if (val) {
					this.formData.SoftwareId = val.SoftwareId
					this.formData.VersionTypeId = val.VersionTypeId
					this.formData.Version = val.Version
				} else {
					this.formData.SoftwareId = ''
					this.formData.VersionTypeId = null
					this.formData.Version = ''
				}
			},
			
			// 展开收起表格
			toggleRowExpansion(){
				this.frpData.map(v=>{
					this.$refs.table.toggleRowExpansion(v,!this.open)
				})
				this.open = !this.open;
			},
			// 添加子节点
			setFrpItems(row1,row2){
				row2.frpClientAgents.push({
					frpClientId: row2.Id,
					modify: true,
					criteria: true
				})
			},
			// 保存\编辑子节点信息
			setRowModify(row, ind, modify) {
				if (modify) { // 点击的保存
					var patt = /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/g;
					var result = patt.test(row.local_ip);
					var patt1 = /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/g;
					var result1 = patt1.test(row.local_port)
					// return console.log(result)
					if (!row.name || !row.type || !row.local_ip || !row.local_port) return this.$message.error('请填写完整信息')
					if (!result) return this.$message.error('请输入正确的客户端IP')
					if (!result1) return this.$message.error('请输入正确的客户端端口')
					this.$confirm('是否确定此代理信息？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$http.setClientAgent(row).then(res => {
							if (res.data.Code != 200) return this.$message.error(res.data.MsgText)
							this.$message.success('添加成功')
							row.modify = false
							this.getAllClientAgent(row.frpClientId)
						})
					})
				} else { // 点击的是编辑
					row.modify = true;
				}
			},
			// 删除\取消子节点信息
			delRowModify(row, ind, modify,row2) {
				this.$confirm('是否删除该穿透节点？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = `?frpClientAgentId=${row.Id}`
					this.$http.delClientAgent(data).then(res => {
						if (res.data.Code != 200) return this.$message.error(res.data.MsgText)
						// row2.frpClientAgents.splice(ind,1)
						this.getPaginatedClient()
						this.$message.success('删除成功')
					})
				})
				return
				if (modify) { // 取消修改该节点
					if(row.oldData){
						row.local_ip = row.oldData.local_ip
						row.local_port = row.oldData.local_port
						row.custom_domains = row.oldData.custom_domains
						row.remote_port = row.oldData.remote_port
						row.use_encryption = row.oldData.use_encryption
						row.use_gzip = row.oldData.use_gzip
					}else{
						row2.frpClientAgents.splice(ind,1)
					}
					row.modify = false
				} else {
					this.$confirm('是否删除该穿透节点？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						var data = `?frpClientAgentId=${row.Id}`
						this.$http.delClientAgent(data).then(res => {
							if (res.data.Code != 200) return this.$message.error(res.data.MsgText)
							this.$message.success('删除成功')
							row2.frpClientAgents.splice(ind,1)
							this.getPaginatedClient()
						})
					})
				}
			},

			// 删除frp记录
			delFprItem(row, ind) {
				this.$confirm('是否删除该穿透节点？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = `?frpClientId=${row.fid}`
					this.$http.delClient(data).then(res => {
						if (res.data.Code != 200) return this.$message.error(res.data.MsgText)
						this.getPaginatedClient()
						this.$message.success('删除成功')
						// this.frpData.splice(ind, 1)
					})
				})
			},
			// 修改穿透节点
			modifyPenetration(row) {
				// console.log(row)
				var data = "?clientId=" + row.fid + "&frpServerId=" + row.frpServerId
				this.$http.revampPenetrate(data).then(res => {
					if (res.data.Code != 200) return this.$message.error(res.data.MsgText)
					this.$message.success('修改成功')
				})
			},
			// 添加单条frp
			setFrp(e){
				this.$refs.nodeForm.validate(v=>{
					if(v){
						this.$http.addPaginatedClient(e).then(res => {
							if (res.data.Code != 200) return this.$message.error(res.data.MsgText)
							this.$message.success(res.data.MsgText)
							this.getPaginatedClient()
							this.dialog = false
						})
					}
				})
			},
	
			// 更改当前页数时触发
			handleCurrentChange(e) {
				this.query.num = e
				this.getPaginatedClient()
			},
			// 更改显示条数时触发
			handleSizeChange(e) {
				this.query.size = e
				this.getPaginatedClient()
			},

			// 筛选公司编号
			remoteMethod(val) {
				// 正则，匹配当前项是否是19位，同时是数字或字母
				function isNum(val) {
					var pattern = /^[A-Za-z0-9]{19}$/
					return pattern.test(val)
				}
				// 为空不做操作
				if (!val) return
				if (isNum(val)) var data = `?companyId=${val}`
				else var data = `?likeCompanyName=${val}`
				this.$http.getCompanyList(data).then(res => {
					if (res.status != 200) return
					this.companyList = res.data
				})
			},
			// 搜索框防抖
			SearchAntiShake(){
				let timer
				if (timer) {
					clearTimeout(timer);
				}
				timer = setTimeout(() => {
					this.getPaginatedClient()
					timer = undefined;
				}, 1000);
			},

			// 查询所有穿透节点
			getPaginatedClient() {
				var queryData = {...this.query}
				if(!queryData.frpServerId){
					queryData.frpServerId = 0
				}
				var data = {
					query: `/${ this.query.num }/${ this.query.size }`,
					data: queryData
				}
				this.$http.getPaginatedClient(data).then(res => {
					console.log(res)
					if (res.status != 200) return
					var cData = []
					res.data.Items.map(v => {
						v.frpClientAgents.map((e,ind) => {
							this.$set(e, "modify", false)
							this.$set(e, "SoftwareInd", ind)
						})
						if(v.frpClientAgents.length<1){
							var aa = {
								// ...this.formData,
								fid:v.Id,
								CompanyId:v.CompanyId,
								CompanyName:v.Company.CompanyName,
								frpServer:v.frpServer,
								frpServerId:v.frpServerId
							}
							cData.push(aa)
						} else {
							var aa = v.frpClientAgents.map(r =>{
								this.$set(r,'fid',v.Id)
								this.$set(r,'CompanyId',v.CompanyId)
								this.$set(r,'CompanyName',v.Company.CompanyName)
								this.$set(r,'frpServer',Object.assign({},v.frpServer))
								this.$set(r,'frpServerId',v.frpServerId)
								return r
							})
							cData.push(...aa)
						}
					})
					// 赋值frp穿透信息
					// console.log(cData)
					// this.frpData = res.data.Items;
					this.spanArr = []
					this.frpData = cData
					this.rowspan()
					this.open = true;
					// 赋值总页数
					this.total = res.data.TotalCount;
				})
			},
			// 查询所有主机地址
			getFrpAll() {
				this.$http.getFrpAll().then(res => {
					// return console.log(res)
					if (res.status != 200) return this.$message.error(res.data.MsgText)
					this.servers = res.data.map(v => {
						v.label = `${v.ServerAddress}:${v.ServerPort}`
						return v
					})
				})
			},
			//查询所有软件版本信息
			getSoftwareVerAll() {
				let data = '' // 未防止访问接口类型错误
				this.$http.getAllSoftwareVer(data).then(res => {
					console.log(res)
					if (res.status != 200) return
					this.edition = res.data.map(v => {
						v.label = `${v.Software.Name}-${v.SoftwareVersionType.Name}-${v.Version}`
						return v
					})
				})
			},
		}
	}
</script>

<style scoped>
	.mb-20 {
		margin-bottom: 20px;
	}

	.pagesContent {
		width: 100%;
		height: 100%;
	}

	.main-box {
		width: 100%;
		background-color: #FFFFFF;
	}

	/*单击表格单条信息 弹框样式 */
	.dialog-body {
		height: 60vh;
		box-sizing: border-box;
		overflow: auto;
		/* 超出滑动 */
		padding: 30px;
	}

	/* 单个添加 弹框样式 */
	.dialog-body-add {
		height: 40vh;
		box-sizing: border-box;
		padding: 0 40px 0 80px;
	}

	/* 勾选框 */
	.el-checkbox /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
		border-color: #409EFF;
		background-color: #409EFF;
	}

	.el-checkbox /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
		border-color: #FFFFFF;
	}
</style>
